<template>
  <div class="container-fluid bg-dark px-0" id="headerContainer">
    <div class="row gx-0">
      <div class="col-lg-2 bg-dark d-none d-lg-block">
        <router-link to="/anasayfa" class="navbar-brand w-100 h-100 m-0 p-0 d-flex align-items-center justify-content-center">
          <!-- Logo Görseli -->
          <img :src="logo" alt="AĞ-DER Logo" style="max-height: 40px;" />
        </router-link>
      </div>
      <div class="col-lg-10">
        <nav class="navbar navbar-expand-lg bg-dark navbar-dark p-3 p-lg-0 mobile-site-nav">
          <router-link to="/anasayfa" class="navbar-brand d-flex d-lg-none mobile-logo">
            <img :src="logo" alt="AĞ-DER Logo" />
          </router-link>
          <router-link to="/anasayfa" class="mobile-brand-title d-lg-none">
            Ankara Ağrılılar
          </router-link>
          <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse justify-content-between" id="navbarCollapse">
            <div class="navbar-nav mr-auto py-0">
              <router-link to="/anasayfa" @click="closeNavbar" class="nav-item nav-link" active-class="active">Anasayfa</router-link>
              <router-link to="/firmalar" @click="closeNavbar" class="nav-item nav-link" active-class="active">Firmalarımız</router-link>
              <router-link to="/hakkimizda" @click="closeNavbar" class="nav-item nav-link" active-class="active">Hakkımızda</router-link>
              <router-link to="/etkinlikler" @click="closeNavbar" class="nav-item nav-link" active-class="active">Etkinliklerimiz</router-link>
              <router-link to="/haberler" @click="closeNavbar" class="nav-item nav-link" active-class="active">Haberler</router-link>
              <router-link to="/hizmetlerimiz" @click="closeNavbar" class="nav-item nav-link" active-class="active">Hizmetlerimiz</router-link>
              <router-link to="/kurucular" @click="closeNavbar" class="nav-item nav-link" active-class="active">Kurucular</router-link>
              <router-link to="/kurullar" @click="closeNavbar" class="nav-item nav-link" active-class="active">Kurullar</router-link>
              <router-link to="/iletisim" @click="closeNavbar" class="nav-item nav-link" active-class="active">İletişim</router-link>
              <router-link to="/sss" @click="closeNavbar" class="nav-item nav-link" active-class="active">Bilgi</router-link>
              <a :href="whatsappJoinUrl" target="_blank" rel="noopener" @click="closeNavbar" class="nav-item nav-link join-link">Katıl</a>
            </div>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { Collapse } from 'bootstrap'
import logo from '@/assets/logo_dark.png'

export default {
  name: 'NavBar',
  data() {
    return {
      logo,
      whatsappJoinUrl: `https://wa.me/905079217404?text=${encodeURIComponent('Derneğinize websitesinden katıldım, herkese merhabalar.')}`
    }
  },
  methods: {
    closeNavbar() {
      const navbarCollapse = document.getElementById('navbarCollapse')
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        const collapse = Collapse.getInstance(navbarCollapse) || new Collapse(navbarCollapse, { toggle: false })
        collapse.hide()
      }
    }
  }
}
</script>

<style scoped>
.mobile-logo img {
  max-height: 38px;
  width: auto;
}

.mobile-brand-title {
  display: none;
}

@media (max-width: 991.98px) {
  .mobile-site-nav {
    min-height: 64px;
    display: grid;
    grid-template-columns: 48px minmax(0, 1fr) 48px;
    align-items: center;
    gap: 10px;
    padding: 10px 14px !important;
  }

  .mobile-logo {
    width: 48px;
    height: 44px;
    align-items: center;
    justify-content: flex-start;
    margin: 0;
  }

  .mobile-brand-title {
    display: block;
    color: #fff;
    font-size: 18px;
    font-weight: 900;
    line-height: 1.1;
    text-align: center;
    white-space: nowrap;
  }

  .mobile-brand-title:hover {
    color: var(--primary);
  }

  .navbar-toggler {
    width: 44px;
    height: 42px;
    justify-self: end;
    padding: 6px;
  }

  #navbarCollapse {
    grid-column: 1 / -1;
  }
}

@media (max-width: 360px) {
  .mobile-brand-title {
    font-size: 16px;
  }
}
</style>
